<template>

  <component :is="layout">

    <nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
      <div class="container-fluid">
        <a class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block" href="#">
          <i class="fas fa-user"></i> {{ $i18n.t('user.profile') }}
        </a>

        <ul class="navbar-nav align-items-center d-none d-md-flex">
          <li class="nav-item dropdown">
            <a class="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="media align-items-center">
                <span v-if="user" class="photoURL avatar avatar-sm rounded-circle" :style="{ 'background-image': 'url('+user.photoURL+')' }">
                </span>
                <div class="media-body ml-2 d-none d-lg-block">
                  <span class="mb-0 text-sm  font-weight-bold">{{ user ? user.displayName : '' }}</span>
                </div>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
              <Menu key="User" />
            </div>
          </li>
        </ul>

      </div>
    </nav>

    <div class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center" style="min-height: 600px; background-image: url(https://images.unsplash.com/photo-1521897258701-21e2a01f5e8b?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=2850&amp;q=80); background-size: cover; background-position: center top;">
      <!-- Mask -->
      <span class="mask bg-gradient-default opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-md-12">
            <h1 class="display-2 text-white mt-0 mb-5">Hello {{ user && user.displayName ? user.displayName : '' }}</h1>
            <!-- <p class="text-white mt-0 mb-5">This is your profile page. You can see the progress you've made with your work and manage your projects or assigned tasks</p> -->
            <!-- <a href="#!" class="btn btn-info">Edit profile</a> -->
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div class="card card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <button v-if="user && user.photoURL" class="border-0" type="button" data-toggle="modal" data-target="#photoURL">
                    <img :src="user.photoURL" :alt="user.displayName" class="rounded-circle" id="user-image">
                  </button>
                </div>
                <div v-if="user" class="modal fade" id="photoURL" tabindex="-1" role="dialog" :aria-labelledby="user.displayName" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">{{ $i18n.t('user.photo') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <img :src="user.photoURL" :alt="user.displayName" class="img-responsive">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col">
                  <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                    <div>
                      <span class="heading">{{ booksCount }}</span>
                      <span class="description">{{ $i18n.t('global.books') }}</span>
                    </div>
                    <div>
                      <span class="heading">{{ coinsCount }}</span>
                      <span class="description">{{ $i18n.t('global.coins') }}</span>
                    </div>
                    <div>
                      <span class="heading">{{ banknotesCount }}</span>
                      <span class="description">{{ $i18n.t('global.banknotes') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-8 order-xl-1">
          <div class="card bg-secondary shadow">
            <div class="card-header bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">{{ $i18n.t('user.profile') }}</h3>
                </div>
                <div class="col-4 text-right">
                  <!-- <a href="#" @click.prevent="updateUser()" class="btn btn-sm btn-primary">{{ $i18n.t('global.save') }}</a> -->
                </div>
              </div>
            </div>
            <div class="card-body">
              <form>
                <h6 class="heading-small text-muted mb-4">{{ $i18n.t('user.info') }}</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group focused">
                        <label class="form-control-label" for="input-username">{{ $i18n.t('user.displayName') }}</label>
                        <input type="text" v-model="editUser.displayName" id="input-username" class="form-control form-control-alternative">
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="form-control-label" for="input-email">{{ $i18n.t('user.email') }}</label>
                        <input type="email" v-model="editUser.email" id="input-email" class="form-control form-control-alternative">
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group focused">
                        <label class="form-control-label" for="input-first-name">{{ $i18n.t('user.firstname') }}</label>
                        <input type="text" v-model="editUser.firstname" id="input-first-name" class="form-control form-control-alternative">
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group focused">
                        <label class="form-control-label" for="input-last-name">{{ $i18n.t('user.lastname') }}</label>
                        <input type="text" v-model="editUser.lastname" id="input-last-name" class="form-control form-control-alternative">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group focused">
                        <label class="form-control-label" for="input-password">{{ $i18n.t('user.password') }}</label>
                        <input type="password" v-model="editUser.password" id="input-password" class="form-control form-control-alternative">
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group focused">
                        <label class="form-control-label">Display username or fullname</label>
                        <div class="custom-control custom-radio mb-3">
                          <input :checked="editUser.choose === 'username'" v-model="editUser.choose" value="username" class="custom-control-input" id="customRadio1" type="radio">
                          <label class="custom-control-label" for="customRadio1">Choose username</label>
                        </div>
                        <div class="custom-control custom-radio mb-3">
                          <input :checked="editUser.choose === 'fullname'" v-model="editUser.choose" value="fullname" class="custom-control-input" id="customRadio2" type="radio">
                          <label class="custom-control-label" for="customRadio2">Choose full name</label>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
                <hr class="my-4">
                <!-- Address -->
                <h6 class="heading-small text-muted mb-4">{{ $i18n.t('user.photo') }}</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <div class="input-group input-group-alternative">
                          <div class="dropdown full-width">
                            <button class="btn btn-secondary dropdown-toggle full-width bg-white" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <span v-if="editUser.photoURL">
                                <i class="far fa-thumbs-up"></i>
                              </span>
                              <span v-else>
                                {{ $i18n.t('register.choose_image') }}
                              </span>
                            </button>
                            <div class="dropdown-menu full-width" aria-labelledby="dropdownMenuButton">
                              <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1524673450801-b5aa9b621b76?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                                <img class="full-width" src="https://images.unsplash.com/photo-1524673450801-b5aa9b621b76?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80" alt="Image">
                              </a>
                              <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                                <img class="full-width" src="https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80" alt="Image">
                              </a>
                              <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1533094700036-70ecccc6f047?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                                <img class="full-width" src="https://images.unsplash.com/photo-1533094700036-70ecccc6f047?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80" alt="Image">
                              </a>
                              <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1526913299589-f35a3ddeb7ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                                <img class="full-width" src="https://images.unsplash.com/photo-1526913299589-f35a3ddeb7ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80" alt="Image">
                              </a>
                              <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1519162584292-56dfc9eb5db4?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                                <img class="full-width" src="https://images.unsplash.com/photo-1519162584292-56dfc9eb5db4?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80" alt="Image">
                              </a>
                              <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1524673278499-6c651bf78b14?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                                <img class="full-width" src="https://images.unsplash.com/photo-1524673278499-6c651bf78b14?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80" alt="Image">
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>

  </component>

</template>

<script>
import Footer from '../../layouts/Footer'
import Menu from '../../layouts/Menu'

export default {
  name: 'BookShow',
  components: { Footer, Menu },
  data () {
    return {
      editUser: {
        displayName: '',
        photoURL: '',
        email: '',
        password: '',
        firstname: '',
        lastname: '',
        choose: 'username'
      },
      error: null,
      loading: false
    }
  },
  computed: {
    layout () {
      return 'Layout'
    },
    user () {
      let user = this.$store.getters.user
      if (user) {
        this.editUser.displayName = user.displayName
        this.editUser.photoURL = user.photoURL
        this.editUser.email = user.email
      }
      return user
    },
    booksCount () {
      return this.$store.getters.books ? this.$store.getters.books.length : 0
    },
    coinsCount () {
      return this.$store.getters.coinsCount
    },
    banknotesCount () {
      return this.$store.getters.banknotesCount
    }
  },
  created () {
    this.$store.dispatch('fetchUser')
    this.$store.dispatch('fetchBooks')
    this.$store.dispatch('fetchCoinsCount')
    this.$store.dispatch('fetchBanknotesCount')
  },
  methods: {
    selectPhotoURL (photoURL) {
      this.editUser.photoURL = photoURL
    },
    updateUser () {
      this.editUser.updated_at = new Date().toISOString()
      console.log('updateUser', this.editUser, this.user)
    }
  }
}
</script>

<style scoped>
  .width-100 { width: 100px; }
  .border-0 { outline: none; }
  #user-image {
    height: 180px;
    width: 180px;
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/User/Profile.vue